import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { MemberFetchStatus } from '@bo-components/members';
import { PATHS } from '@bo-constants/routes';
import { useEffect } from 'react';
import { useMembers } from '@bo-hooks/members';

export const MemberSupport = () => {
  const { uuid = '' } = useParams<{ uuid?: string }>();
  const {
    formattedMembers,
    isFetchingMembersError,
    isFetchingMembersSuccess,
    isLoadingMembers
  } = useMembers({
    memberSearchFilters: {
      dateOfBirth: '',
      email: '',
      firstName: '',
      joinDate: undefined,
      lastName: '',
      memberId: '',
      pushNotificationToken: '',
      uuid
    }
  });

  const navigate = useNavigate();
  const { MEMBERS: membersPath } = PATHS;
  const memberId = formattedMembers?.members[0]?.id;

  useEffect(() => {
    if (!isLoadingMembers && isFetchingMembersSuccess && memberId) {
      navigate(`/members/${memberId}/profile`);
    }
  }, [isFetchingMembersSuccess, isLoadingMembers, memberId, navigate]);

  return (
    <div className="m-auto flex w-full flex-col items-center justify-center gap-4 pt-16 text-center">
      <MemberFetchStatus
        isError={isFetchingMembersError}
        isLoading={isLoadingMembers}
        isMemberNotFound={!memberId}
        loadingMessage="Searching for member..."
      />
      {!isLoadingMembers && !memberId && (
        <NavLink
          className="bg-stankonia-100 text-soClean-100 w-36 rounded-md px-3 py-2 text-base font-medium"
          data-testid="go-to-search"
          to={membersPath}
        >
          Search Member
        </NavLink>
      )}
    </div>
  );
};
